/**
 * The PriorityLayerHost is a div which is created in place
 * where you want to host portaled content which should be "on top" (like Messages)
 */
import { forwardRef } from 'preact/compat';

const TopLayerHost = forwardRef<HTMLDivElement>((_props, ref) => {
  return <div id="__top_layer_host" ref={ref} />;
});

TopLayerHost.displayName = 'Forwarded<TopLayerHost>';

export default TopLayerHost;
